/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Draft_Take_OutInputs */

const en_us2_draft_take_out = /** @type {(inputs: Draft_Take_OutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Take it out`)
};

const pt_br2_draft_take_out = /** @type {(inputs: Draft_Take_OutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tirar do plano`)
};

const es_419_draft_take_out = /** @type {(inputs: Draft_Take_OutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quitar del plan`)
};

const pt_pt2_draft_take_out = /** @type {(inputs: Draft_Take_OutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tirar do plano`)
};

const fr_fr2_draft_take_out = /** @type {(inputs: Draft_Take_OutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Le retirer`)
};

const de_de2_draft_take_out = /** @type {(inputs: Draft_Take_OutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Herausnehmen`)
};

const it_it2_draft_take_out = /** @type {(inputs: Draft_Take_OutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Toglilo`)
};

/**
* | output |
* | --- |
* | "Take it out" |
*
* @param {Draft_Take_OutInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const draft_take_out = /** @type {((inputs?: Draft_Take_OutInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Draft_Take_OutInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_draft_take_out(inputs)
	if (locale === "es-419") return es_419_draft_take_out(inputs)
	if (locale === "pt-PT") return pt_pt2_draft_take_out(inputs)
	if (locale === "fr-FR") return fr_fr2_draft_take_out(inputs)
	if (locale === "de-DE") return de_de2_draft_take_out(inputs)
	if (locale === "it-IT") return it_it2_draft_take_out(inputs)
	return en_us2_draft_take_out(inputs)
});
export { draft_take_out as "draft.take_out" }